import React from "react";
import BorderedDisplay from "../Shared/UiKit/BorderedDisplay";
import Helper from "../Shared/Helper";
import CVStore from "../CarteVitale/CVStore";

const PatientCvDiff = ({patient, meta, current_patient, onDone}) => {

    const firstname_diff = current_patient.prenom !== patient.sPrenomPatient
    const lastname_diff = current_patient.nom !== patient.sNomUsuelPatient
    const birthdate_diff = Helper.formatDate(current_patient.birthday) !== Helper.formatDate(patient.dDateDeNaissance)
    const ssn_diff = current_patient.num_carte_vitale !== patient.sNumeroSecuriteSocialePatient
    const birth_rank_diff = current_patient.birth_rank !== patient.nRangNaissance
    const patient_code_diff = current_patient.regime_code !== meta.sCodeRegime || current_patient.fund_code !== meta.sCodeCaisse || current_patient.centre_code !== meta.sCodeCentre

    const saveAll = () => {
        CVStore.updatePatientV2(patient, meta).then(onDone)
    }

    const saveSecuOnly = () => {

        CVStore.updatePatientV2({
            sNumeroSecuriteSocialePatient: patient.sNumeroSecuriteSocialePatient,
            nRangNaissance: patient.nRangNaissance
        }, meta).then(onDone)
    }

    return <div className="fc gap-20">
        <div className="fr gap-20">
            <div style={{width: "45%"}}>
                <div style={{backgroundColor: "#C8E6C9", borderRadius: 10}}>
                    <BorderedDisplay text="Patient sur la carte vitale" containerStyle={{borderRadius: 10}}>
                        <p style={{fontWeight: firstname_diff ? 600 : 400}}>
                            Prénom : {patient.sPrenomPatient}
                        </p>
                        <p style={{fontWeight: lastname_diff ? 600 : 400}}>
                            Nom : {patient.sNomUsuelPatient}
                        </p>
                        <p style={{fontWeight: birthdate_diff ? 600 : 400}}>
                            Date de naissance : {Helper.formatDate(patient.dDateDeNaissance)}
                        </p>
                        <p style={{fontWeight: ssn_diff ? 600 : 400}}>
                            Num. sécu. : {patient.sNumeroSecuriteSocialePatient}
                        </p>
                        <p style={{fontWeight: birth_rank_diff ? 600 : 400}}>
                            Rang de naissance : {patient.nRangNaissance}
                        </p>
                        <p style={{fontWeight: patient_code_diff ? 600 : 400}}>
                            Code établissement : {meta.sCodeRegime} {meta.sCodeCaisse} {meta.sCodeCentre}
                        </p>
                    </BorderedDisplay>
                </div>
            </div>
            <div className="fr" style={{width: "10%", alignItems: "center", justifyContent: "center"}}>
                <i className="material-icons black-text large">arrow_right</i>
            </div>
            <div style={{width: "45%"}}>
                <BorderedDisplay text="Patient du dossier actuel">
                    <p style={{fontWeight: firstname_diff ? 600 : 400}}>
                        Prénom : {current_patient.prenom}
                    </p>
                    <p style={{fontWeight: lastname_diff ? 600 : 400}}>
                        Nom : {current_patient.nom}
                    </p>
                    <p style={{fontWeight: birthdate_diff ? 600 : 400}}>
                        Date de naissance : {Helper.formatDate(current_patient.birthday)}
                    </p>
                    <p style={{fontWeight: ssn_diff ? 600 : 400}}>
                        Num. sécu. : {current_patient.num_carte_vitale}
                    </p>
                    <p style={{fontWeight: birth_rank_diff ? 600 : 400}}>
                        Rang de naissance : {current_patient.birth_rank}
                    </p>
                    <p style={{fontWeight: patient_code_diff ? 600 : 400}}>
                        Code établissement
                        : {current_patient.regime_code} {current_patient.fund_code} {current_patient.centre_code}
                    </p>
                </BorderedDisplay>
            </div>

        </div>
        <div className="fc gap-5">
            <div className="fr" style={{justifyContent: "center"}}>
                <a className="btn blue darken-2 z-depth-0" onClick={saveAll}>
                    Tout importer
                </a>
                <a className="btn blue darken-2 z-depth-0" onClick={saveSecuOnly}>
                    Importer seulement les données de sécu
                </a>
                <a className="btn red darken-2 z-depth-0" onClick={onDone}>
                    Ne rien importer
                </a>
            </div>
            <div className="fr" style={{justifyContent: "center"}}>
                <label>Les données de sécu correspondent à : Num. Sécu, Rang Naissance et Code établissement</label>
            </div>
        </div>
    </div>
}

PatientCvDiff.defaultProps = {
    data: [],
    meta: {},
    current_patient: {},
    patient: {}

}

export default PatientCvDiff;